module.exports = __webpack_public_path__ + "static/media/ticket.f398b177.svg";